import Icon from '../components/Icon.vue'

Icon.register({
  'star-half-alt': {
    width: 536,
    height: 512,
    paths: [
      {
        d: 'M508.6 171.5L362.2 150.2 296.8 17.8C290.9 6 279.4 0 267.9 0 256.6 0 245.2 5.9 239.3 17.8L173.8 150.2 27.4 171.5C1.2 175.3-9.3 207.6 9.7 226.1L115.6 329.1 90.5 474.6C87 495.3 103.6 512 122.2 512 127.1 512 132.2 510.8 137 508.3L268 439.6 398.9 508.3C403.8 510.8 408.8 512 413.7 512 432.3 512 449 495.4 445.4 474.6L420.4 329.1 526.3 226.1C545.3 207.6 534.8 175.3 508.6 171.5zM386.8 294.7L368.7 312.3 373 337.2 392.5 450.7 290.4 397.1 268 385.3 268 68.1 319 171.4 330.2 194.1 355.2 197.7 469.5 214.3 386.8 294.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-half-alt.js
// module id = 6XMY
// module chunks = 144